import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import EntityType from '@/models/Shared/EntityType';
import { InactivityReportRequest, InactivityReportResponse } from '@/models/Reports/InactivityReport';

const ENTITY_TO_PATH: Partial<Record<EntityType, string>> = {
    [EntityType.Company]: 'companies',
    [EntityType.Location]: 'locations',
    [EntityType.Contact]: 'contacts',
    [EntityType.Opportunity]: 'opportunities',
};

export interface IInactivityReportState {
    loading: boolean;
    request: InactivityReportRequest;
    response: InactivityReportResponse | null;
}

@Module({ dynamic: true, store, name: 'InactivityReport', namespaced: true })
class InactivityReport extends VuexModule implements IInactivityReportState {
    public loading = false;
    public request: InactivityReportRequest = new InactivityReportRequest();
    public response: InactivityReportResponse | null = null;

    @Mutation
    setLoading(v: boolean) { this.loading = v; }

    @Mutation
    setResponse(r: InactivityReportResponse | null) { this.response = r; }

    @Mutation
    setRequest(r: InactivityReportRequest) { this.request = r; }

    @Mutation
    patchRequest(p: Partial<InactivityReportRequest>) {
        this.request = Object.assign({}, this.request, p);
    }

    @Action
    async run() {
        const path = ENTITY_TO_PATH[this.request.entityType];
        if (!path) {
            return;
        }
        this.setLoading(true);
        try {
            const response = await ajax.post(`/api/v1/agency/reports/inactivity/${path}`, this.request);
            this.setResponse(response.data);
        } catch (error) {
            AppModule.handleApiError(error);
            this.setResponse(null);
        } finally {
            this.setLoading(false);
        }
    }

    @Action
    cleanState() {
        this.context.commit('resetState');
    }

    @Mutation
    resetState() {
        this.loading = false;
        this.request = new InactivityReportRequest();
        this.response = null;
    }
}

export const InactivityReportModule = getModule(InactivityReport);
